import React from "react";
import { Router, Switch } from "react-router-dom";

import SideMenu from "../components/SideMenu";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";

import Inicio from "./Inicio";
import Page404 from "./404";
import ConsultaTipoAcaoFiscal from "./Parametrizacao/TipoAcaoFiscal/ConsultaTipoAcaoFiscal";
import ConsultaCiclo from "./Parametrizacao/Ciclo/ConsultaCiclo";
import FormCiclo from "./Parametrizacao/Ciclo/FormCiclo";
import FormTipoAcaoFiscal from "./Parametrizacao/TipoAcaoFiscal/FormTipoAcaoFiscal";
import ConsultaProcedimento from "./Parametrizacao/Procedimento/ConsultaProcedimento";
import FormProcedimento from "./Parametrizacao/Procedimento/FormProcedimento";
import ConsultaTextoPadrao from "./Parametrizacao/TextoPadrao/ConsultaTextoPadrao";
import FormTextoPadrao from "./Parametrizacao/TextoPadrao/FormTextoPadrao";
import Page403 from "./403";
import ConsultaFase from "./Parametrizacao/Fase/ConsultaFase";
import FormFase from "./Parametrizacao/Fase/FormFase";
import PendenciaProcedimentoFiscal from "./SPF/PendenciaProcedimentoFiscal";
import FormProcedimentoFiscal from "./SPF/FormProcedimentoFiscal";
import HomologaProcedimentoFiscal from "./SPF/HomologaProcedimentoFiscal";
import ConsultaProcedimentoFiscal from "./SPF/ConsultaProcedimentoFiscal";
import ConsultaAtividadePadrao from "./Parametrizacao/AtividadePadrao/ConsultaAtividadePadrao";
import FormAtividadePadrao from "./Parametrizacao/AtividadePadrao/FormAtividadePadrao";
import FormGerarOrdemServico from "./OS/FormGerarOrdemServico";
import ConsultaGerarOrdemServico from "./OS/ConsultaGerarOrdemServico";
import ConsultaDadosOs from "./OS/ConsultaDadosOs/ConsultaDadosOs";
import FormSpfGerarOs from "./OS/FormSpfGerarOs";
import FormSpfGerarOsLote from "./OS/FormSpfGerarOsLote";
import ConsultaOrigemOrdemServico from "./OS/ConsultaOrigemOrdemServico";
import FormOrigemGerarOs from "./OS/FormOrigemGerarOs";

import { funcionalidades } from "../context/AuthContext";
import OrigemProcedimentoFiscal from "./SPF/OrigemProcedimentoFiscal";
import ConsultaDetalheProcedimentoFiscal from "./SPF/ConsultaDetalheProcedimentoFiscal";
import Notificacoes from "./Notificacao/Notificacoes";
import ExecutaOS from "./OS/ExecutarOrdemServico/ExecutarOrdemServico";
import ConsultaRoteiro from "./Parametrizacao/Roteiro/ConsultaRoteiro";
import FormRoteiro from "./Parametrizacao/Roteiro/FormRoteiro";
import ConsultaLivroFiscal from "./Parametrizacao/TabelaOperacional/ConsultaLivroFiscal";
import FormLivroFiscal from "./Parametrizacao/TabelaOperacional/FormLivroFiscal";
import AssinaturaFila from "./Assinatura/AssinaturaFila";
import CustomRoutes from "./CustomRoutes";
import ErrorBoundary from "./ErrorBoundary";
import ConsultaTipoDivergencia from "./Parametrizacao/TipoDivergencia/ConsultaTipoDivergencia";
import FormTipoDivergencia from "./Parametrizacao/TipoDivergencia/FormTipoDivergencia";
import ConsultaTipoOcorrencia from "./Parametrizacao/Ocorrencia/ConsultaOcorrencia";
import FormOcorrencia from "./Parametrizacao/Ocorrencia/FormOcorrencia";
import ConsultaOcorrenciaDetalhes from "./Parametrizacao/Ocorrencia/ConsultaOcorrenciaDetalhes";
import ConsultaTipoParteServico from "./Parametrizacao/TipoParteServico/ConsultaTipoParteServico";
import FormTipoParteServico from "./Parametrizacao/TipoParteServico/FormTipoParteServico";
import ConsultaModeloImportacao from "./Parametrizacao/ModeloImportacao/ConsultaModeloImportacao";
import FormModeloImportacao from "./Parametrizacao/ModeloImportacao/FormModeloImportacao";
import ConsultaTextoParteServico from "./Parametrizacao/TextoParteServico/ConsultaTextoParteServico";
import FormTextoParteServico from "./Parametrizacao/TextoParteServico/FormTextoParteServico";
import ConsultaTipoInaptidao from "./Parametrizacao/TipoInaptidao/ConsultaTipoInaptidao";
import FormTipoInaptidao from "./Parametrizacao/TipoInaptidao/FormTipoInaptidao";
import FormOcorrenciasAF from "./OS/Ocorrencias/FormOcorrenciasAF";
import FormDemonstrativos from "./OS/Ocorrencias/FormDemonstrativos";
import ListaDemonstrativos from "./OS/Ocorrencias/ListaDemonstrativos";
import FormExpedienteAtipico from "./Parametrizacao/ExpedienteAtipico/FormExpedienteAtipico";
import ParteServico from "./OS/ParteServico/ParteServico";
import FormParteServico from "./OS/ParteServico/FormParteServico";
import ConsultarOrdemServico from "./OS/ConsultarOrdemServico/ConsultarOrdemServico";
import ExpedienteAtipico from "./Parametrizacao/ExpedienteAtipico/ExpedienteAtipico";

const Layout = ({ history, match }) => (
  <div id="wrapper">
    <SideMenu history={history} />
    {/* Container de conteúdo */}
    <div id="content-wrapper" className="d-flex flex-column">
      {/* Conteúdo principal */}
      <div id="content">
        <Topbar history={history} />
        <div className="container-fluid">
          <ErrorBoundary>
            <Router history={history}>
              <Switch>
                <CustomRoutes isPrivate exact path={`${match.url}`} component={Inicio} />
                <CustomRoutes isPrivate exact path={`${match.url}/home`} component={Inicio} />
                <CustomRoutes isPrivate exact path={`${match.url}/assinatura`} component={AssinaturaFila} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/ciclo`}
                  component={ConsultaCiclo}
                  permissao={funcionalidades.ciclo.consultar}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/ciclo/form`} component={FormCiclo} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/tipoAcaoFiscal`}
                  component={ConsultaTipoAcaoFiscal}
                  permissao={funcionalidades.tipoAcaoFiscal.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/tipoAcaoFiscal/form`}
                  component={FormTipoAcaoFiscal}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/procedimento`}
                  component={ConsultaProcedimento}
                  permissao={funcionalidades.procedimentoFiscal.consultar}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/procedimento/form`} component={FormProcedimento} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/textopadrao`}
                  component={ConsultaTextoPadrao}
                  permissao={funcionalidades.textoPadrao.consultar}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/textopadrao/form`} component={FormTextoPadrao} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/fase`}
                  component={ConsultaFase}
                  permissao={funcionalidades.fase.consultar}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/fase/form`} component={FormFase} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/pendencias`}
                  component={PendenciaProcedimentoFiscal}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/pendencias/form`}
                  component={FormProcedimentoFiscal}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/form`}
                  component={FormProcedimentoFiscal}
                  permissao={funcionalidades.spf.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/origem`}
                  component={OrigemProcedimentoFiscal}
                  permissao={funcionalidades.spf.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/consulta`}
                  component={ConsultaProcedimentoFiscal}
                  permissao={funcionalidades.spf.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/homologa`}
                  component={HomologaProcedimentoFiscal}
                  permissao={funcionalidades.spf.homologar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/atividadePadrao`}
                  component={ConsultaAtividadePadrao}
                  permissao={funcionalidades.ciclo.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/atividadePadrao/form`}
                  component={FormAtividadePadrao}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/pendencias/detalhe/:itemKey`}
                  component={ConsultaDetalheProcedimentoFiscal}
                  // permissao={funcionalidades.spf.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/spf/pendencias/detalhe`}
                  component={ConsultaDetalheProcedimentoFiscal}
                  // permissao={funcionalidades.spf.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/executarOs`}
                  component={ExecutaOS}
                  permissao={funcionalidades.os.executar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/executarOs/consulta`}
                  component={ConsultaDadosOs}
                  permissao={funcionalidades.os.executarDetalhe}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/executarOs/ocorrencias/incluir`}
                  component={FormOcorrenciasAF}
                  permissao={funcionalidades.os.executarDetalhe}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/roteiro`} component={ConsultaRoteiro} />
                <CustomRoutes isPrivate exact path={`${match.url}/roteiro/form`} component={FormRoteiro} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/gerarOs`}
                  component={ConsultaGerarOrdemServico}
                  permissao={funcionalidades.ordemservico.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/form`}
                  component={FormGerarOrdemServico}
                  permissao={funcionalidades.ordemservico.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/spf/form`}
                  component={FormSpfGerarOs}
                  permissao={funcionalidades.ordemservico.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/spf/form/lote`}
                  component={FormSpfGerarOsLote}
                  permissao={funcionalidades.ordemservico.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/origem`}
                  component={ConsultaOrigemOrdemServico}
                  permissao={funcionalidades.ordemservico.inserir}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/origem/form`}
                  component={FormOrigemGerarOs}
                  permissao={funcionalidades.ordemservico.inserir}
                />

                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/consultarOs`}
                  component={ConsultarOrdemServico}
                  permissao={funcionalidades.ordemservico.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/os/consultarOs/consulta`}
                  component={ConsultaDadosOs}
                  permissao={funcionalidades.ordemservico.consultar}
                />

                <CustomRoutes isPrivate exact path={`${match.url}/403`} component={Page403} />
                <CustomRoutes isPrivate exact path={`${match.url}/notificacoes`} component={Notificacoes} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/livrofiscal`}
                  component={ConsultaLivroFiscal}
                  permissao={funcionalidades.livroFiscal.consultar}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/livrofiscal/form`} component={FormLivroFiscal} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/tipodivergencia`}
                  component={ConsultaTipoDivergencia}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/tipodivergencia/form`}
                  component={FormTipoDivergencia}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/ocorrencia`} component={ConsultaTipoOcorrencia} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/ocorrencia/consulta`}
                  component={ConsultaOcorrenciaDetalhes}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/ocorrencia/form`} component={FormOcorrencia} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/tipoparteservico`}
                  component={ConsultaTipoParteServico}
                  permissao={funcionalidades.tipoParteServico.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/tipoparteservico/form`}
                  component={FormTipoParteServico}
                  permissao={funcionalidades.tipoParteServico.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/modeloimportacao`}
                  component={ConsultaModeloImportacao}
                  permissao={funcionalidades.modeloImportacao.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/modeloimportacao/form`}
                  component={FormModeloImportacao}
                  permissao={funcionalidades.modeloImportacao.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/textoparteservico`}
                  component={ConsultaTextoParteServico}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/textoparteservico/form`}
                  component={FormTextoParteServico}
                />
                <CustomRoutes isPrivate exact path={`${match.url}/tipoinaptidao`} component={ConsultaTipoInaptidao} />
                <CustomRoutes isPrivate exact path={`${match.url}/tipoinaptidao/form`} component={FormTipoInaptidao} />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/ocorrencia/demonstrativo`}
                  component={FormDemonstrativos}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/ocorrencia/listaDemonstrativos`}
                  component={ListaDemonstrativos}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/parteservico`}
                  component={ParteServico}
                  permissao={funcionalidades.parteServico.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/parteservico/form`}
                  component={FormParteServico}
                  permissao={funcionalidades.parteServico.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/expedienteatipico/form`}
                  component={FormExpedienteAtipico}
                  permissao={funcionalidades.expedienteAtipico.consultar}
                />
                <CustomRoutes
                  isPrivate
                  exact
                  path={`${match.url}/expedienteatipico`}
                  component={ExpedienteAtipico}
                  permissao={funcionalidades.expedienteAtipico.consultar}
                />
                <CustomRoutes isPrivate path="*" component={Page404} />
              </Switch>
            </Router>
          </ErrorBoundary>
        </div>
      </div>
      <Footer />
    </div>
  </div>
);

export default Layout;
